import { AfterViewInit, Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';
import { State, Store } from 'src/app/interface/menu.interface';
import { AuthenticateService } from 'src/app/service/authenticate.service';
import { CartService } from 'src/app/service/cart.service';
import { CommonService } from 'src/app/service/common.service';
import { MenuService } from 'src/app/service/menu.service';
import { UserService } from 'src/app/service/user.service';

@Component({
  selector: 'app-store-popup',
  templateUrl: './store-popup.component.html',
  styleUrls: ['./store-popup.component.css']
})
export class StorePopupComponent implements OnInit {

  storeList: Store[];
  stateList: State[];
  selectedStore: Store;
  selectedState: State;
  isLoading: boolean = false;

  searchText: string;
  first: Store;
  locationpermission: boolean = false;

  constructor(
    private menuService: MenuService,
    private userService: UserService,
    private commonService: CommonService,
    private cartService: CartService,
    private authService: AuthenticateService,
    public dialogRef: MatDialogRef<StorePopupComponent>,
    @Inject(MAT_DIALOG_DATA) private data,
  ) {
  }

  ngOnInit(): void {
    this.userService.selectedStore$
      .pipe(take(1))
      .subscribe((storeData) => {
        if (!storeData) {
          return;
        }
        this.selectedStore = storeData;
        this.first = storeData;
      });


    let thisfunc = this;
    navigator.permissions && navigator.permissions.query({ name: 'geolocation' })
      .then(function (PermissionStatus) {
        if (PermissionStatus.state == 'granted') {
          thisfunc.locationpermission = true;
        } else {
          thisfunc.locationpermission = false;
        }
      })

    // .then(() => {
    this.userService.getUserLocationPayload().then((postData) => {
      let list_store = '1';
      this.menuService.getStore(postData, list_store).subscribe((response) => {
        if (!response.success) {
          return;
        }
        this.menuService.setStore(response.data);
        this.storeList = response.data;
        if (!this.selectedStore) {
          this.userService.setSelectedStore(response.data[0]);
        }
      });

    });
    //--get states list
    this.authService.getState().subscribe((response) => {
      this.stateList = response.data;
    });
    // });
  }

  selectStore(store: Store): void {
    this.cartService.getCartV2().pipe(take(1)).subscribe(() => {
      const cartItems = this.cartService.cartLength();
      console.log('cartItems', cartItems);
      console.log('store', this.selectedStore);
      if (cartItems > 0) {
        let dialogResponse = this.commonService.actionDialog('Alert', 'You have a save cart with ' + this.selectedStore.name + '. By changing stores, your saved cart will be cleared.', 'Continue');
        dialogResponse.subscribe(data => {
          if (data) {
            this.cartService.clearCartV2().pipe(take(1)).subscribe(() => {
              this.selectedStore = store;
              this.first = store;
              this.userService.setSelectedStore(store);
              this.dialogRef.close({ updated: true });
            });
          }
        });
        return;
      }
      this.first = store;
      this.userService.setSelectedStore(store);
      this.selectedStore = store;
      this.dialogRef.close({ updated: true });
    });
  }

  slug(str: string): string {
    return this.commonService.dashCase(str);
  }

  onClose(): void {
    this.dialogRef.close({ updated: this.checkSameStoreSelected() });
  }

  private checkSameStoreSelected(): boolean {
    let updated = false;
    if (this.first && this.selectedStore && this.first.id !== this.selectedStore.id) {
      updated = true;
      this.userService.setSelectedStore(this.selectedStore);
    }
    return updated;
  }

  // Simple onChange function
  onStateChange(event: any): void {
    // console.log('Selected state changed:', event.value);
    // console.log('Current selectedState value:', this.selectedState);
    this.isLoading = true;
    this.userService.getUserLocationPayload().then((postData) => {
      this.menuService.getStore(postData, '1', event.value).subscribe((response) => {
        if (!response.success) {
          this.isLoading = false;
          return;
        }
        this.menuService.setStore(response.data);
        this.storeList = response.data;
        this.isLoading = false;
        // if(!this.selectedStore) {
        //   this.userService.setSelectedStore(response.data[0]);
        // }
      });
    });
  }

  getLocation(): void {
    this.isLoading = true;
    this.selectedState = null;
    this.searchText = null;
    this.commonService.getLocation().then((location) => {
      if (location.lat && location.lon) {

        this.userService.getUserLocationPayload().then((postData) => {
          this.menuService.getStore(postData, '1').subscribe((response) => {
            if (!response.success) {
              return;
            }
            this.menuService.setStore(response.data);
            this.storeList = response.data;
            this.isLoading = false;
            // if(!this.selectedStore) {
            //   this.userService.setSelectedStore(response.data[0]);
            // }
          });
        });

      } else {
        this.isLoading = false;
        this.commonService.alertDialog('Alert', 'Location permission is denied. Please enable location permission in your browser settings to find the nearest store.');
        return;
      }
    });

  }
}
